








































import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import LoadingIndicator from '@components/LoadingIndicator'
import RequestButton from '@/components/RequestButton'
import EventScheduleOfferResourceList from '@ui/EventSchedule/EventScheduleOfferResourceList'
import AddEventScheduleTriggerModal from '@triggers/EventSchedule/AddEventScheduleTriggerModal'

settings =
  name: "EventSchedule"
  components: { Modal, LoadingIndicator, RequestButton, EventScheduleOfferResourceList, AddEventScheduleTriggerModal }
  resources:
    schedules:
      resourceName: 'event_schedules'
      slug: 'event_schedules'
      fetch: false
    schedule:
      resourceName: 'event_schedule'
      slug: 'event_schedules/:scheduleId'
    offers:
      infinityScroll: true
      resourceName: 'offers'
      slug: 'event_schedules/:scheduleId/offers'
  vue:
    props: ['scheduleId']

    data: ->
      bulkActionResultItems: []

      editScheduleModal:
        modal =
          show: false
          data:
            name: ''

    computed:
      offerListOptions: -> { resourceComponent : this, hideRowSize: true }
      totalDraftOffersCount: ->
        _this = this
        count = 0
        @schedules.forEach((sch) ->
          count += _this.draftOffersCountForSchedule(sch)
        )
        count

    methods:
      fetchResource: (state, resourceKey, data = {}, options={}) ->
        @fetchInfinity(state, resourceKey, data, options)

      addEventScheduleTrigger: ->
        payloadOptions = {}
        @$refs.addEventScheduleTrigger.fire(payloadOptions)
      onSchedulesAddEventSchedule: (data, response) ->
        @setAppSession('selectedEventSchedule', response)
        @fetch('schedules')
        @fetchAllResources()
        @$refs.addEventScheduleTrigger.close()

      hiOpenEditScheduleModal: ->
        @editScheduleModal.data.name = @schedule.name
        @editScheduleModal.show = true

      hiUpdateSchedule: ->
        @schedule.name = @editScheduleModal.data.name
        @saveItemField('schedule', 'name')

      onSave: (item) ->
        @editScheduleModal =
          show: false
          data:
            name: ''
        @setAppSession('selectedEventSchedule', item)

      draftOffersCountForSchedule: (sch) ->
        @ctxStats(sch)?.offer?.draft_count || 0

    watch:
      '$route.params.offerId': -> @fetchAllResources()

      scheduleId: ->
        @fetchAllResources()

export default VueOptions.vue settings
